import { initCookieBanner } from '@nocn/cookie-policy-banner';
import InitAnalytics from './Analytics';

export default function initCookieBannerService() {
  initCookieBanner({
    apiKey: process.env.REACT_CIVIC_UK_API_KEY,
    product: 'PRO_MULTISITE',
    policyUrl: 'https://www.nocn.org.uk/privacy/',
    necessaryCookies: ['__stripe*', 'XSRF-TOKEN'],
    optionalCookies: [
      {
        name: 'analytics',
        label: 'Analytics',
        description: 'We use cookies for analytics',
        cookies: ['_ga*', '_gid*', '_gat*'],
        onAccept: () => {
          InitAnalytics();
        },
        onRevoke: () => {
          document.cookie.split(';').forEach((cookie) => {
            const name = cookie.split('=')[0].trim();
            if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
              window.CookieControl.delete(name);
            }
          });
        },
      },
    ],
    initialState: 'closed',
    onLoad: () => {
      if (window.CookieControl && window.CookieControl.getCategoryConsent(0)) {
        InitAnalytics();
      }
    },
    onError: (error) => {
      console.error('Cookie banner error:', error);
    },
  });
}
